import React from "react";

const PisysTable = ({ thead, tbody }) => (
  <div className="tooltip__text">
    <div className="table-restrictions">
      <table className="detail-pisys-info__product">
        {thead}
        {tbody}
      </table>
    </div>
  </div>
);

export default PisysTable;
